export default "__VITE_ASSET__afc38808__"